<template>
  <section class="all_emp card_style">
    <div class="main_header_style mb-2">
      <div class="d-flex align-items-center gap-3">
        <AddFavDailog v-tooltip.left="$t('add_to_favourite')" />
        <h4 class="mb-0">
          {{ $t("Stages") }}
        </h4>
      </div>

      <div>
        <router-link
          to="/stage_percentages/add"
          class="PrimaryButton mt-0 btn w-100"
          ><i class="fa-solid fa-plus"></i> {{ $t("Add_new_stage") }}
        </router-link>
      </div>
    </div>

    <!-- <div class="search-visa my-3">
      <form>
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          type="text"
          class="form-control"
          :placeholder="$t('search...')"
        />
      </form>
    </div> -->

    <div class="row table-responsive">
      <table class="table" id="VisaTable">
        <thead>
          <tr>
            <th class="text-center">ID</th>
            <th class="text-center">{{ $t("title") }}</th>
            <th class="text-center">{{ $t("Stage-1") }}</th>
            <th class="text-center">{{ $t("Stage-2") }}</th>
            <th class="text-center">{{ $t("Stage-3") }}</th>
            <th class="text-center">{{ $t("Stage-4") }}</th>
            <th class="text-center">{{ $t("Control") }}</th>
          </tr>
        </thead>

        <tbody v-if="loading" class="text-center">
          <tr v-for="profit in 10" :key="profit">
            <td v-for="profit in 7" :key="profit">
              <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr v-for="(profit, index) in profits.data" :key="index">
            <td v-if="profit.stages.length">{{ profit.id }}</td>
            <td v-if="profit.stages.length">
              {{ profit.title ? profit.title : "_" }}
            </td>
            <td v-if="profit.stages.length">
              {{ profit.stages.length ? profit.stages[0].title : "" }}
              <p>
                Direct ->
                {{
                  profit.stages.length
                    ? profit.stages[0].stage_profits[0].profit
                    : ""
                }}
              </p>
            </td>
            <td v-if="profit.stages.length">
              {{ profit.stages.length ? profit.stages[1].title : "" }}
              <p class="mb-0">
                Direct ->
                {{
                  profit.stages.length
                    ? profit.stages[1].stage_profits[0].profit
                    : ""
                }}
              </p>
              <p>
                InDirect One ->
                {{
                  profit.stages.length
                    ? profit.stages[1].stage_profits[1].profit
                    : ""
                }}
              </p>
            </td>
            <td v-if="profit.stages.length">
              {{ profit.stages.length ? profit.stages[2].title : "" }}
              <p class="mb-0">
                Direct ->
                {{
                  profit.stages.length
                    ? profit.stages[2].stage_profits[0].profit
                    : ""
                }}
              </p>
              <p class="mb-0">
                InDirect Two ->
                {{
                  profit.stages.length
                    ? profit.stages[2].stage_profits[1].profit
                    : ""
                }}
              </p>
              <p class="mb-0">
                InDirect One ->
                {{
                  profit.stages.length
                    ? profit.stages[2].stage_profits[2].profit
                    : ""
                }}
              </p>
            </td>
            <td v-if="profit.stages.length">
              {{ profit.stages.length ? profit.stages[3].title : "" }}
              <p class="mb-0">
                Direct ->
                {{
                  profit.stages.length
                    ? profit.stages[3].stage_profits[0].profit
                    : ""
                }}
              </p>
              <p class="mb-0">
                InDirect Three ->
                {{
                  profit.stages.length
                    ? profit.stages[3].stage_profits[1].profit
                    : ""
                }}
              </p>
              <p class="mb-0">
                InDirect Two ->
                {{
                  profit.stages.length
                    ? profit.stages[3].stage_profits[2].profit
                    : ""
                }}
              </p>
              <p class="mb-0">
                InDirect One ->
                {{
                  profit.stages.length
                    ? profit.stages[3].stage_profits[3].profit
                    : ""
                }}
              </p>
            </td>
            <td v-if="profit.stages.length">
              <button
                @click="deleteProfit(profit.id, index)"
                class="btn btn-danger mx-1 w-auto"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div class="row">
      <pagination
        :data="profits"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchCoupons"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div> -->
  </section>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import axios from "axios";
import Skeleton from "primevue/skeleton";
// import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
// import $ from "jquery";
export default {
  name: "allVisa",
  components: {
    AddFavDailog,
    // pagination,
    Skeleton,
  },
  data() {
    return {
      profits: [],
      loading: true,
    };
  },
  methods: {
    async fetchCoupons() {
      await axios.get(`/affiliate_category_with_stages`).then(({ data }) => {
        this.profits = data.data;
        this.loading = false;
        // console.log(this.profits, "this.profitswww");
      });
    },
    //delete visa
    deleteProfit(id, index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          // let delete_id = this.allVisa.data[index].id;
          const fromClick = true;
          axios.delete(`/affiliate_categories/${id}`, { fromClick }).then(({ data }) => {
            if (data.status == true) {
              Swal.fire("", this.$t("success_delete"), "success");
              this.profits.data.splice(index, 1); // Remove the deleted item from the array
            } else {
              Swal.fire("", data.message, "error");
            }
            return data;
          });
        }
      });
    },
  },
  mounted() {
    this.fetchCoupons();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
// @import "./_visa.scss";

.main_header_style {
  align-items: center;
  h4 {
    margin-bottom: 0;
  }
}
.search-visa {
  form {
    position: relative;
    i {
      position: absolute;
      top: 12px;
      right: 15px;
      color: #9ca2ac;
    }
    input {
      padding-right: 40px !important;
    }
  }
}
</style>
